import { ReactNode } from "react";
import { BarChart, BarChartProps } from "./BarChart";

interface BarChartWithHeaderProps extends BarChartProps {
  icon: ReactNode;
  title?: string;
  subtitle?: string;
}

export function BarChartWithHeader({
  title,
  subtitle,
  icon,
  data,
  label,
  extraAccessorLabel,
  extraAccessorKey,
  min,
  max,
  accessorLabel,
  suffix,
}: BarChartWithHeaderProps) {
  return (
    <div className="flex flex-col">
      <div className="flex gap-6 items-center mb-4">
        <div className="w-16 h-16 bg-indigo-300 rounded-full flex justify-center items-center">
          {icon}
        </div>
        <div className="flex flex-col gap-2">
          <p className="leading-none text-2xl font-bold">{title}</p>
          <p className="leading-none font-regular text-gray-500">{subtitle}</p>
        </div>
      </div>
      <BarChart
        data={data}
        label={label}
        extraAccessorLabel={extraAccessorLabel}
        extraAccessorKey={extraAccessorKey}
        min={min}
        max={max}
        accessorLabel={accessorLabel}
        suffix={suffix}
      />
    </div>
  );
}
